import React, { useState } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import { Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import gql from "graphql-tag";
import { getCustomerTeam, itemsByStatus } from "../../graphql/queries";
import * as actionTypes from "../../redux/actions";
import { getVehicleDefects, archivedDefects } from "../../data/customQueries";
import { connect } from "react-redux";
import { spinnerService } from "@chevtek/react-spinners";
import { Link } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import { Storage } from "aws-amplify";
let tractor = require("../../assets/img/tractor-128.png");
let van = require("../../assets/img/van.png");
let bus = require("../../assets/img/bus.png");
let truck = require("../../assets/img/truck.png");
let trailer = require("../../assets/img/trailer.png");
let pickup = require("../../assets/img/pickup.png");

// const useStyles = makeStyles(theme => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 120
//   },
//   selectEmpty: {
//     marginTop: theme.spacing(2)
//   }
// }));

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
const CustomTableCell = withStyles(theme => ({
  head: {
    color: "black",
    fontSize: 14,
    marginTop: "0px"
  },
  body: {
    fontSize: 12
  }
}))(TableCell);

const DispTable = ({ defectsSelected, start, end }) => {
  const [showMore, setShowMore] = useState(false);
  const [dispMore, setDispMore] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const tableHeads = [
    "Type",
    "Description",
    "Reported At",
    "Status",
    "Source",
    "Red Tag",
    "Priority",
    " ",
    " "
  ];
  const handleChangePage = (event, page) => {
    // 
    setPage(page);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };
  const handleShowMore = (flag, id) => {
    setShowMore(flag);
    if (flag === true) {
      setDispMore(id);
    } else {
      setDispMore("");
    }
  };
  const DescDisplay = ({ desc, id }) => {
    return (
      <React.Fragment>
        {desc.length > 20 ? (
          <React.Fragment>
            {!showMore ? (
              <Typography>
                {desc.slice(0, 20)}...
                <Typography
                  style={{
                    fontSize: "10px",
                    color: "rgb(50, 136, 255)",
                    cursor: "pointer"
                  }}
                  onClick={() => handleShowMore(true, id)}
                >
                  Show More
                </Typography>
              </Typography>
            ) : (
              <React.Fragment>
                {dispMore === id ? (
                  <Typography>
                    {desc}
                    <Typography
                      style={{
                        fontSize: "10px",
                        color: "rgb(50, 136, 255)",
                        cursor: "pointer"
                      }}
                      onClick={() => handleShowMore(false, id)}
                    >
                      Show Less
                    </Typography>
                  </Typography>
                ) : (
                  <Typography>
                    {desc.slice(0, 20)}...
                    <Typography
                      style={{
                        fontSize: "10px",
                        color: "rgb(50, 136, 255)",
                        cursor: "pointer"
                      }}
                      onClick={() => handleShowMore(true, id)}
                    >
                      Show More
                    </Typography>
                  </Typography>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <Typography>{desc} </Typography>
        )}
      </React.Fragment>
    );
  };
  return (
    <Paper
      style={{
        width: "100%",
        marginTop: 1,
        overflowX: "auto"
      }}
    >
      <Table
        style={{
          maxWidth: "100%"
        }}
        padding="checkbox"
      >
        <TableHead>
          <TableRow>
            {tableHeads.map((h, i) => (
              <CustomTableCell key={i}>{h}</CustomTableCell>
            ))}
          </TableRow>
        </TableHead>
        {defectsSelected.length > 0 ? (
          <TableBody>
            {defectsSelected
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                let reportedAt = moment(row.reportedDateTime).fromNow();
                return (
                  <TableRow key={row.id}>
                    <CustomTableCell>{row.defectType}</CustomTableCell>
                    <CustomTableCell>
                      {row.defectDesc !== null ? (
                        <CustomTableCell align="right">
                          <DescDisplay desc={row.defectDesc} id={row.id} />
                        </CustomTableCell>
                      ) : (
                        "--No Descrition--"
                      )}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      {reportedAt}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      {row.status}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      {row.sourceType}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      {row.redTag ? "true" : "false"}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      {row.priority}
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      <Link
                        to={{
                          pathname: `/defects/detail/${row.id}`
                          // client: { client }
                        }}
                      >
                        Detail
                      </Link>
                    </CustomTableCell>
                    <CustomTableCell align="right">
                      <Link
                        to={{
                          pathname: `/defects/work/order/${row.id}`,
                          state: { description: row.defectDesc }
                        }}
                      >
                        WorkOrder
                      </Link>
                    </CustomTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <CustomTableCell colSpan={9}>
                <div
                  style={{
                    marginLeft: "45%",
                    fontSize: 16
                  }}
                >
                  {"No record found"}
                </div>
              </CustomTableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={defectsSelected.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page"
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page"
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "#CCE5FF",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: 5,
    minHeight: 40,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: 2
  }
}))(MuiExpansionPanelDetails);

class TableList extends React.Component {
  state = {
    start: 0,
    end: 10,
    defects: [],
    defectInsp: [],
    defectsOtf: [],
    defectsSelected: [],
    activeTab: "1",
    tableHeading: "",
    vehicle: {},
    url: "",
    selectedSource: "",
    expanded: ""
  };
  loadData = async id => {
    try {
      let { activeTab, vehicle } = this.state;
      let query = activeTab === "1" ? getVehicleDefects : archivedDefects;
      spinnerService.show("mySpinner");
      const { client, user, empProfile } = this.props;
      let custUsername = user.username;
      let userType = null;
      if (
        user !== null &&
        user !== "notFound" &&
        user.signInUserSession.idToken.payload["cognito:groups"] !== undefined
      ) {
        userType = user.signInUserSession.idToken.payload["cognito:groups"][0];
      }
      if (userType === "Dispatchers" || userType === "Technicians") {
        let emp = null;
        if (
          empProfile === undefined ||
          empProfile === "" ||
          empProfile === null
        ) {
          emp = (await client.query({
            query: gql(getCustomerTeam),
            fetchPolicy: `network-only`,
            variables: { id: user.username }
          })).data.getCustomerTeam;
        } else emp = empProfile;
        this.props.storeEmpProfile(emp);
        custUsername = emp.customer.id;
      }
      const data = await client.query({
        query: gql(query),
        fetchPolicy: `network-only`,
        variables: { id: this.props.match.params.vid, limit: 50 }
      });

      vehicle.customerVehicleId = data.data.getVehicle.customerVehicleId;
      vehicle.vehicleType = data.data.getVehicle.vehicleType;
      vehicle.mainPic = data.data.getVehicle.mainPic;
      this.setState(
        {
          defects: data.data.getVehicle.defects.items,
          defectsSelected: data.data.getVehicle.defects.items,
          defectsOtf: data.data.getVehicle.defects.items.filter(
            dt => dt.sourceType === "ONTHEFLY"
          ),
          defectInsp: data.data.getVehicle.defects.items.filter(
            dt => dt.sourceType !== "ONTHEFLY"
          )
        },
        () => {
          if (this.state.defectsOtf.length === 0) {
            this.setState({
              expanded: "Inspection"
            });
          } else {
            this.setState({
              expanded: "On The Fly"
            });
          }
        }
      );
      spinnerService.hide("mySpinner");
    } catch (error) {
      spinnerService.hide("mySpinner");
    }
  };
  async componentDidMount() {
    let { vehicle } = this.state;
    if (this.props.data === undefined || this.props.data.length == 0) {
      await this.loadData(this.props.match.params.vid);
    }
    if (vehicle.mainPic) this.getUrl(vehicle.mainPic.key);
    else
      this.setState({
        url: utilGetVehicleImage(vehicle.vehicleType.vehicleCategory)
      });
  }
  changePage = i => {
    let start = i * 10 - 10,
      end = i * 10;
    this.setState({ start, end });
  };
  getUrl = async key => {
    let url = await Storage.get(key);
    this.setState({ url });
  };
  handleSourceSelect = e => {
    const { selectedSource } = this.state;
    const { value } = e.target;
    if (value === "Otf") {
      this.setState({
        selectedSource: value,
        defectsSelected: this.state.defectsOtf
      });
    }
    if (value === "Insp") {
      this.setState({
        selectedSource: value,
        defectsSelected: this.state.defectInsp
      });
    }
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      value === "All"
    ) {
      this.setState({
        selectedSource: value,
        defectsSelected: this.state.defects
      });
    }
  };
  handleChange = panel => (event, newExpanded) => {
    this.setState({
      expanded: newExpanded ? panel : false
    });
  };
  render() {
    // const classesNew = useStyles();
    const { classes } = this.props;
    let {
      defects,
      activeTab,
      start,
      end,
      vehicle,
      url,
      expanded,
      defectsOtf,
      defectInsp
    } = this.state;
    const expansionPanels = ["On The Fly", "Inspection"];
    return (
      <React.Fragment>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h3>Defects</h3>
            <Card>
              <CardHeader style={{ backgroundColor: "black" }}>
                <Row>
                  <Col sm={1.5}>
                    <span
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "50%"
                      }}
                    >
                      {(vehicle.mainPic || vehicle.vehicleType) && (
                        <img
                          src={url}
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%"
                          }}
                        />
                      )}
                    </span>
                  </Col>
                  <Col sm={4}>
                    <span>
                      {vehicle.vehicleType && (
                        <h4 className={classes.cardTitleWhite}>
                          {vehicle.vehicleType.vehicleType}
                        </h4>
                      )}
                      {vehicle.vehicleType && (
                        <h6 className={classes.cardTitleWhite}>
                          {vehicle.vehicleType.vehicleCategory}
                        </h6>
                      )}
                      {vehicle.customerVehicleId && (
                        <h6 className={classes.cardTitleWhite}>
                          {vehicle.customerVehicleId}
                        </h6>
                      )}
                    </span>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ fontWeight: "bold" }}
                      className={{ active: activeTab === "1" }}
                      onClick={() => {
                        this.setState({ activeTab: "1" }, () =>
                          this.loadData()
                        );
                      }}
                    >
                      Active
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ fontWeight: "bold" }}
                      className={{ active: activeTab === "2" }}
                      onClick={() => {
                        this.setState({ activeTab: "2" }, () =>
                          this.loadData()
                        );
                      }}
                    >
                      Archived
                    </NavLink>
                  </NavItem>
                </Nav>
                <div style={{ width: "100%" }}>
                  {expansionPanels.map(dt => (
                    <ExpansionPanel
                      key={dt}
                      square
                      expanded={expanded === dt}
                      onChange={this.handleChange(dt)}
                    >
                      <ExpansionPanelSummary
                        aria-controls={`${dt}d-content`}
                        id={`${dt}d-header`}
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <Typography variant="title">{dt}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails id={dt}>
                        {dt === "On The Fly" && (
                          <DispTable
                            defectsSelected={defectsOtf}
                            start={start}
                            end={end}
                          />
                        )}
                        {dt === "Inspection" && (
                          <DispTable
                            defectsSelected={defectInsp}
                            start={start}
                            end={end}
                          />
                        )}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  ))}
                  {/* <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="title">On The Fly </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <DispTable
                        defectsSelected={this.state.defectsOtf}
                        start={start}
                        end={end}
                      />
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="title">Inspection </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <DispTable
                        defectsSelected={this.state.defectInsp}
                        start={start}
                        end={end}
                      />
                    </ExpansionPanelDetails>
                  </ExpansionPanel> */}
                </div>
                {/* <DispTable defectsSelected={defectsSelected} /> */}
              </CardBody>
            </Card>
          </GridItem>
          {/* <Pagination
            onPageSelect={this.changePage}
            start={start}
            data={defects}
          /> */}
        </GridContainer>
      </React.Fragment>
    );
  }
}
const utilGetVehicleImage = vehCategory => {
  let src = "";
  switch (vehCategory) {
    case "TRACTOR":
      src = tractor;
      break;
    case "TRUCK":
      src = truck;
      break;
    case "TRAILER":
      src = trailer;
      break;
    case "VAN":
      src = van;
      break;
    case "BUS":
      src = bus;
      break;
    case "PICKUPTRUCK":
      src = pickup;
      break;
  }
  return src;
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    loading: state.config.loading,
    client: state.config.client,
    profile: state.config.profile,
    empProfile: state.config.empProfile,
    vehicleGrid: state.vehicles.vehicleGrid
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeEmpProfile: data => dispatch(actionTypes.storeEmpProfile(data)),
    updateEmpProfile: data => dispatch(actionTypes.updateEmpProfile(data))
  };
};
export default TableList = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TableList));



// WEBPACK FOOTER //
// ./src/views/Defects/Defects.jsx